import React from 'react';
import { Search, RotateCcw } from 'lucide-react';
import './AdminTranslatorFilters.css';

export default function AdminTranslatorFilters({
  search,
  onSearch,
  filters,
  onChange,
  onReset,
  options,
}) {
  const {
    type = '',
    sourceLang = '',
    targetLang = '',
    domain = '',
    translationType = '',
    documentType = '',
    officialService = '',
    interpretingType = '',
    interpretingMission = '',
    interpretingMode = '',
    availability = '',
    statut = '',
  } = filters;

  const {
    languages = {},
    specialties = [],
    translationTypes = [],
    documentTypes = [],
    officialServices = [],
    interpretingTypes = [],
    interpretingMissionTypes = [],
    interpretingModes = [],
  } = options;
  const languageList = Object.entries(languages);

  return (
    <div className="atf">
      <div className="atf-top">
        <div className="atf-search">
          <Search size={16} />
          <input
            type="text"
            value={search}
            onChange={(e) => onSearch(e.target.value)}
            placeholder="Recherche : nom / prénom, email…"
          />
        </div>
        <button type="button" className="atf-reset" onClick={onReset}>
          <RotateCcw size={14} /> Réinitialiser
        </button>
      </div>

      <div className="atf-row">
        <select value={type} onChange={(e) => onChange('type', e.target.value)} className="atf-select">
          <option value="">Tous les profils</option>
          <option value="translator">Traducteur</option>
          <option value="interpreter">Interprète</option>
          <option value="both">Traducteur + Interprète</option>
        </select>

        <select value={sourceLang} onChange={(e) => onChange('sourceLang', e.target.value)} className="atf-select">
          <option value="">Langue source</option>
          {languageList.map(([code, label]) => <option key={code} value={code}>{label}</option>)}
        </select>

        <select value={targetLang} onChange={(e) => onChange('targetLang', e.target.value)} className="atf-select">
          <option value="">Langue cible</option>
          {languageList.map(([code, label]) => <option key={code} value={code}>{label}</option>)}
        </select>

        <select value={domain} onChange={(e) => onChange('domain', e.target.value)} className="atf-select">
          <option value="">Domaine</option>
          {specialties.map((s) => <option key={s} value={s}>{s}</option>)}
        </select>

        {type === 'interpreter' ? (
          <>
            <select value={interpretingType} onChange={(e) => onChange('interpretingType', e.target.value)} className="atf-select">
              <option value="">Type d'interprétation</option>
              {interpretingTypes.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>

            <select value={interpretingMission} onChange={(e) => onChange('interpretingMission', e.target.value)} className="atf-select">
              <option value="">Type de mission</option>
              {interpretingMissionTypes.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>

            <select value={interpretingMode} onChange={(e) => onChange('interpretingMode', e.target.value)} className="atf-select">
              <option value="">Mode d'interprétation</option>
              {interpretingModes.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
          </>
        ) : (
          <>
            <select value={translationType} onChange={(e) => onChange('translationType', e.target.value)} className="atf-select">
              <option value="">Type de traduction</option>
              {translationTypes.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>

            <select value={documentType} onChange={(e) => onChange('documentType', e.target.value)} className="atf-select">
              <option value="">Type de document</option>
              {documentTypes.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>

            <select value={officialService} onChange={(e) => onChange('officialService', e.target.value)} className="atf-select">
              <option value="">Services officiels</option>
              {officialServices.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
          </>
        )}

        <select value={availability} onChange={(e) => onChange('availability', e.target.value)} className="atf-select">
          <option value="">Disponibilité</option>
          <option value="disponible">Disponible</option>
          <option value="partiellement_disponible">Partiellement disponible</option>
          <option value="indisponible">Indisponible</option>
        </select>

        <select value={statut} onChange={(e) => onChange('statut', e.target.value)} className="atf-select">
          <option value="">Statut du compte</option>
          <option value="pending">En attente</option>
          <option value="validated">Validé / Actif</option>
          <option value="info_requested">Informations complémentaires</option>
          <option value="suspended">Suspendu</option>
          <option value="rejected">Refusé</option>
        </select>
      </div>
    </div>
  );
}
